module.exports = __webpack_public_path__ + "static/media/trash.37323d55.svg";